<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bbm-page supplies-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-boxes-stacked"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ "supplies" | transloco }}
            </span>

            <h2>
              {{ "supplies" | transloco }}
            </h2>

            <p>
              {{ "manage inventory" | transloco }}
            </p>
          </div>

        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ totalItems || allData.length }}
          </strong>

          <span>
            {{ "requests" | transloco }}
          </span>
        </div>

      </div>

      <!-- MAIN ACTIONS -->
      <div class="bbm-actions-grid bbm-hero-actions noPrint">

        <button
          type="button"
          routerLink="/suppliesrequest"
          class="bbm-action-btn bbm-action-success"
        >
          <i
            class="fa-solid fa-plus"
            aria-hidden="true"
          ></i>

          <span>
            {{ "supplyRequest" | transloco }}
          </span>
        </button>

        @if(isAdmin){

          <button
            *ngIf="canShowStockTransfer"
            type="button"
            routerLink="/StocktransferHistory.mobile"
            class="bbm-action-btn bbm-action-primary"
          >
            <i
              class="fa-solid fa-arrow-right-arrow-left"
              aria-hidden="true"
            ></i>

            <span>
              {{ "Stock transfer" | transloco }}
            </span>
          </button>

          <div class="dropdown bbm-ticket-menu bbm-action-wide">

            <button
              type="button"
              class="
                bbm-action-btn
                bbm-action-primary
                bbm-action-wide
                dropdown-toggle
              "
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                class="fa-solid fa-warehouse"
                aria-hidden="true"
              ></i>

              <span>
                {{ "Pospage" | transloco }}
              </span>

              <i
                class="fa-solid fa-chevron-down"
                aria-hidden="true"
              ></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end">

              <li *ngFor="let el of allWareHouses">
                <a
                  class="dropdown-item"
                  (click)="applyWareHouse(el.id)"
                >
                  <i
                    class="fa-solid fa-warehouse"
                    aria-hidden="true"
                  ></i>

                  <span>
                    {{ el.name }}
                  </span>
                </a>
              </li>

            </ul>

          </div>

        }

      </div>

    </section>

    @if(noData) {

      <!-- EMPTY STATE -->
      <div class="bbm-empty-state">
        <app-nodata></app-nodata>
      </div>

    }
    @else {

      <!-- SUPPLIES CARDS -->
      <section class="bbm-ticket-list">

        <article
          class="bbm-ticket"
          *ngFor="
            let element of allData;
            index as cardIndex
          "
          [ngClass]="{
            'bbm-ticket-warning': element.status == 'pending',
            'bbm-ticket-success': element.status == 'accepted',
            'bbm-ticket-danger': element.status == 'rejected'
          }"
        >

          <!-- CARD HEADER -->
          <div class="bbm-ticket-top">

            <div
              class="bbm-main-info"
              role="button"
              tabindex="0"
              (click)="details(element)"
              (keydown.enter)="details(element)"
            >

              <div class="bbm-avatar">
                <i
                  class="fa-solid fa-file-invoice"
                  aria-hidden="true"
                ></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ "invoice" | transloco }}
                </span>

                <h3 class="bbm-code-value">
                  #{{ element.id }}
                </h3>
              </div>

            </div>

            <div class="bbm-badges-row">

              @if(element.status == 'pending'){
                <span class="bbm-status-pill bbm-status-warning">
                  <i
                    class="fa-regular fa-clock"
                    aria-hidden="true"
                  ></i>

                  {{ "pending" | transloco }}
                </span>
              }
              @else if(element.status == 'accepted'){
                <span class="bbm-status-pill bbm-status-success">
                  <i
                    class="fa-solid fa-check"
                    aria-hidden="true"
                  ></i>

                  {{ "approved" | transloco }}
                </span>
              }
              @else if(element.status == 'rejected'){
                <span class="bbm-status-pill bbm-status-danger">
                  <i
                    class="fa-solid fa-xmark"
                    aria-hidden="true"
                  ></i>

                  {{ "rejected" | transloco }}
                </span>
              }

              <!-- CARD MENU -->
              <div class="dropdown bbm-ticket-menu">

                <button
                  type="button"
                  class="bbm-menu-btn dropdown-toggle"
                  data-bs-toggle="dropdown"
                  [attr.id]="'supplyMenu' + element.id"
                  aria-expanded="false"
                >
                  <i
                    class="fa-solid fa-ellipsis-vertical"
                    aria-hidden="true"
                  ></i>
                </button>

                <ul
                  class="dropdown-menu dropdown-menu-end"
                  [attr.aria-labelledby]="'supplyMenu' + element.id"
                >

                  <li>
                    <a
                      class="dropdown-item"
                      (click)="details(element)"
                    >
                      <i
                        class="fa-solid fa-circle-info"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "details" | transloco }}
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      class="dropdown-item"
                      (click)="accStatement(element.phone_number)"
                    >
                      <i
                        class="fa-solid fa-file-invoice-dollar"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "accountStatement" | transloco }}
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      class="
                        dropdown-item
                        bbm-dropdown-success
                      "
                      *ngIf="canTakeAction(element)"
                      (click)="acceptRequest(
                        element.id,
                        tolist(element.product_ids),
                        tolist(element.new_qtys),
                        getNewPrice(
                          tolist(element.prices),
                          tolist(element.qtys),
                          tolist(element.new_price),
                          tolist(element.new_qtys)
                        ),
                        tolist(element.new_price),
                        tolist(element.new_qtys),
                        element.type,
                        element.payed
                      )"
                    >
                      <i
                        class="fa-solid fa-check"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "accept" | transloco }}
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      class="
                        dropdown-item
                        bbm-dropdown-danger
                      "
                      *ngIf="canTakeAction(element)"
                      (click)="rejectRequest(element.id)"
                    >
                      <i
                        class="fa-solid fa-xmark"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "reject" | transloco }}
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      class="
                        dropdown-item
                        bbm-dropdown-warning
                      "
                      *ngIf="hasCreditAction(element)"
                      (click)="changeCredit(
                        element.id,
                        element.not_payed,
                        element.payed
                      )"
                    >
                      <i
                        class="fa-solid fa-credit-card"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "changeCredit" | transloco }}
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      class="
                        dropdown-item
                        bbm-dropdown-warning
                      "
                      *ngIf="hasInstallmentAction(element)"
                      (click)="changeInstalimentValues(
                        element.id,
                        element.installment_price,
                        element.installment_period
                      )"
                    >
                      <i
                        class="fa-solid fa-calendar-check"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "changeInstalimentValues" | transloco }}
                      </span>
                    </a>
                  </li>

                </ul>

              </div>

            </div>

          </div>

          <!-- PAYMENT METHOD -->
          <div class="bbm-badges-row">

            @if(element.type == '0'){
              <span class="bbm-badge bbm-badge-success">
                <i
                  class="fa-solid fa-money-bill"
                  aria-hidden="true"
                ></i>

                {{ "cash" | transloco }}
              </span>
            }

            @if(element.type == '1'){
              <span class="bbm-badge bbm-badge-warning">
                <i
                  class="fa-solid fa-credit-card"
                  aria-hidden="true"
                ></i>

                {{ "credit" | transloco }}

                • {{ "not_payed" | transloco }}:
                {{ element.not_payed }}

                • {{ "payed" | transloco }}:
                {{ element.payed }}
              </span>
            }

            @if(element.type == '2'){
              <span class="bbm-badge bbm-badge-dark">
                <i
                  class="fa-solid fa-calendar-days"
                  aria-hidden="true"
                ></i>

                {{ "installment" | transloco }}

                • {{ "installment_period" | transloco }}:
                {{ element.installment_period }}

                • {{ "installment_price" | transloco }}:
                {{ element.installment_price }}
              </span>
            }

          </div>

          <!-- REQUEST DETAILS -->
          <div
            class="
              bbm-details-grid
              bbm-ticket-section
            "
          >

            <!-- REQUEST DATE -->
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-calendar-days"
                aria-hidden="true"
              ></i>

              <span>
                {{ "requested at" | transloco }}
              </span>

              <strong>
                {{ formatDate(element.created_at) }}
              </strong>
            </div>

            <!-- SUPPLIER -->
            <div class="bbm-detail-chip bbm-detail-primary">
              <i
                class="fa-solid fa-truck-field"
                aria-hidden="true"
              ></i>

              <span>
                {{ "supplier_name" | transloco }}
              </span>

              <strong>
                {{ element.supplier_name }}
              </strong>
            </div>

            <!-- REQUESTED BY -->
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-user-pen"
                aria-hidden="true"
              ></i>

              <span>
                {{ "requested by" | transloco }}
              </span>

              <strong>
                {{ element.last_name_requested_by }}
              </strong>
            </div>

            <!-- ACCEPTED BY -->
            <div
              class="bbm-detail-chip"
              [class.bbm-detail-danger]="element.accepted_by == null"
              [class.bbm-detail-success]="element.accepted_by != null"
            >
              <i
                class="fa-solid fa-user-check"
                aria-hidden="true"
              ></i>

              <span>
                {{ "accepted by" | transloco }}
              </span>

              @if(element.accepted_by == null){
                <strong>
                  {{ "not accepted" | transloco }}
                </strong>
              }
              @else {
                <strong>
                  {{ element.accepted_by }}
                </strong>
              }
            </div>

            <!-- NOTE -->
            <div class="bbm-detail-chip bbm-detail-wide">
              <i
                class="fa-solid fa-note-sticky"
                aria-hidden="true"
              ></i>

              <span>
                {{ "note" | transloco }}
              </span>

              @if(
                element.note == undefined ||
                element.note == null ||
                element.note == '' ||
                element.note == 'undefined'
              ){
                <strong>
                  {{ "not specific" | transloco }}
                </strong>
              }
              @else {
                <strong>
                  {{ element.note }}
                </strong>
              }
            </div>

          </div>

          <!-- PRODUCTS -->
          <div class="bbm-products-block">

            <div class="bbm-block-head">
              <span>
                <i
                  class="fa-solid fa-boxes-stacked"
                  aria-hidden="true"
                ></i>

                {{ "products" | transloco }}
              </span>

              <b>
                {{ tolist(element.items).length }}
              </b>
            </div>

            <div class="bbm-products-list">

              <div
                class="bbm-product-row"
                *ngFor="
                  let el of tolist(element.items);
                  let i = index
                "
                [class.bbm-product-hidden]="
                  i > 2 &&
                  !element.showAllProducts
                "
              >
                <div class="bbm-product-name">
                  <strong>
                    {{ i + 1 }}.
                  </strong>

                  {{
                    drawProducts(
                      el,
                      tolist(element.prices)[i],
                      tolist(element.qtys)[i],
                      tolist(element.new_price)[i],
                      tolist(element.new_qtys)[i]
                    )
                  }}
                </div>
              </div>

            </div>

            <div
              class="bbm-actions-grid"
              *ngIf="tolist(element.items).length > 3"
            >
              <button
                type="button"
                class="
                  bbm-action-btn
                  bbm-action-primary
                  bbm-action-compact
                  bbm-action-wide
                "
                (click)="toggleProducts(element)"
              >
                <i
                  class="fa-solid"
                  [class.fa-chevron-down]="!element.showAllProducts"
                  [class.fa-chevron-up]="element.showAllProducts"
                  aria-hidden="true"
                ></i>

                <span *ngIf="!element.showAllProducts">
                  +{{ tolist(element.items).length - 3 }}
                  {{ "more" | transloco }}
                </span>

                <span *ngIf="element.showAllProducts">
                  {{ "Show less" | transloco }}
                </span>
              </button>
            </div>

          </div>

          <!-- APPROVE / REJECT ACTIONS -->
          <div
            class="
              bbm-actions-grid
              bbm-ticket-section
            "
            *ngIf="canTakeAction(element)"
          >

            <button
              type="button"
              class="bbm-action-btn bbm-action-danger"
              (click)="rejectRequest(element.id)"
            >
              <i
                class="fa-solid fa-xmark"
                aria-hidden="true"
              ></i>

              <span>
                {{ "reject" | transloco }}
              </span>
            </button>

            <button
              type="button"
              class="bbm-action-btn bbm-action-success"
              (click)="acceptRequest(
                element.id,
                tolist(element.product_ids),
                tolist(element.new_qtys),
                getNewPrice(
                  tolist(element.prices),
                  tolist(element.qtys),
                  tolist(element.new_price),
                  tolist(element.new_qtys)
                ),
                tolist(element.new_price),
                tolist(element.new_qtys),
                element.type,
                element.payed
              )"
            >
              <i
                class="fa-solid fa-check"
                aria-hidden="true"
              ></i>

              <span>
                {{ "accept" | transloco }}
              </span>
            </button>

          </div>

        </article>

      </section>

      <!-- LOAD MORE -->
      <div
        class="bbm-actions-grid"
        *ngIf="page < totalPages"
      >
        <button
          type="button"
          class="
            bbm-action-btn
            bbm-action-primary
            bbm-action-wide
          "
          [disabled]="isLoadingMore"
          (click)="loadMore()"
        >
          <span
            *ngIf="isLoadingMore"
            class="bbm-loader-spinner"
            aria-hidden="true"
          ></span>

          <i
            *ngIf="!isLoadingMore"
            class="fa-solid fa-chevron-down"
            aria-hidden="true"
          ></i>

          <span *ngIf="!isLoadingMore">
            {{ "see more" | transloco }}
          </span>

          <span *ngIf="isLoadingMore">
            {{ 'Loading...' | transloco }}
          </span>
        </button>
      </div>

    }

  </div>
</section>

<!-- CREDIT POPUP -->
<div
  *ngIf="showRejectPopUp"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <!-- MODAL HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i
            class="fa-solid fa-credit-card"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ "credit" | transloco }}
          </span>

          <h3>
            {{ "changeCredit" | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
        [attr.aria-label]="'close' | transloco"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <!-- CREDIT FORM -->
    <div class="bbm-modal-list">

      <div class="bbm-form-grid">

        <div class="bbm-field">
          <label for="not_payed">
            {{ "not_payed" | transloco }}
          </label>

          <input
            class="bbm-control"
            type="text"
            id="not_payed"
            [(ngModel)]="not_payed"
            [placeholder]="'not_payed' | transloco"
          >
        </div>

        <div class="bbm-field">
          <label for="payed">
            {{ "payed" | transloco }}
          </label>

          <input
            class="bbm-control"
            type="text"
            id="payed"
            [(ngModel)]="payed"
            [placeholder]="'payed' | transloco"
          >
        </div>

      </div>

    </div>

    <!-- MODAL ACTIONS -->
    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="onSubmit()"
      >
        <i
          class="fa-solid fa-check"
          aria-hidden="true"
        ></i>

        <span>
          {{ "Submit" | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ "close" | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>

<!-- INSTALLMENT POPUP -->
<div
  *ngIf="showinstalimentPopUp"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <!-- MODAL HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i
            class="fa-solid fa-calendar-check"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ "installment" | transloco }}
          </span>

          <h3>
            {{ "changeInstalimentValues" | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
        [attr.aria-label]="'close' | transloco"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <!-- INSTALLMENT FORM -->
    <div class="bbm-modal-list">

      <div class="bbm-form-grid">

        <div class="bbm-field">
          <label for="instaliment_price">
            {{ "installment_price" | transloco }}
          </label>

          <input
            class="bbm-control"
            type="text"
            id="instaliment_price"
            [(ngModel)]="instaliment_price"
            [placeholder]="'installment_price' | transloco"
          >
        </div>

        <div class="bbm-field">
          <label for="instaliment_period">
            {{ "installment_period" | transloco }}
          </label>

          <input
            class="bbm-control"
            type="text"
            id="instaliment_period"
            [(ngModel)]="instaliment_period"
            [placeholder]="'installment_period' | transloco"
          >
        </div>

      </div>

    </div>

    <!-- MODAL ACTIONS -->
    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="onSubmitInstaliment()"
      >
        <i
          class="fa-solid fa-check"
          aria-hidden="true"
        ></i>

        <span>
          {{ "Submit" | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ "close" | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>
